export default __webpack_public_path__ + "pgnv-assets/0b4c4e3052f6ceab27cd3fa0218168e2.svg";